import React, {useContext} from 'react'
import {withTranslation} from 'react-i18next'
import DatePicker from 'react-datepicker'
import {Form} from 'react-bootstrap'
import './AuditSummary.styles.scss'
import {AuditDetailsContext} from '../../../../context/Modal/AuditDetails'
import {AuditPaneContext} from '../../../../context/AuditPane'
import {RecurringDetailsContext} from '../../../../context/Modal/RecurringDetails'
import {GroupDetailsContext} from '../../../../context/Modal/GroupDetails'
import {AssignAuditContext} from '../../../../context/Modal/AssignAudit'
import auditRecurringFormatter from '../../../../utils/auditRecurringFormatter'
import {auditFilterFormatter} from '../../../../utils/auditDatePeriodFormatter'

function Summary(props) {
  const {
    name,
    method,
    start_date,
    due_date,
    due_soon_days,
    gps_location,
    signature,
    asset_details,
    allow_scanning_after_due_date,
  } = useContext(AuditDetailsContext)
  const paneState = useContext(AuditPaneContext)
  const {recurrence_attributes} = useContext(RecurringDetailsContext)

  const {
    audit_entities_attributes,
    allow_auto_update_fields,
    allow_user_update_fields,
    allow_user_without_edit_permission,
  } = useContext(GroupDetailsContext)

  const {
    audit_users_attributes,
    individual_audit,
    audit_email_users_attributes,
    audit_user_templates_attributes,
  } = useContext(AssignAuditContext)

  const getFilterWithCounts = () => {
    let prev = 'null'
    let current = 'null'
    let i = 0
    let counter = 0
    let filters_count = []

    let filters = audit_entities_attributes[0].audit_entity_filters_attributes

    filters.forEach(element => {
      current = element.field_name
      filters.forEach(element1 => {
        if (current === element1.field_name) {
          counter++
        }
      })
      if (current !== prev) {
        filters_count.push({id: i, field_name: current, count: counter})
      }
      i++
      counter = 0
      prev = current
    })
    return filters_count
  }

  const {t} = props
  return (
    <>
      <form className="form-data audit-forms summary_page">
        {name !== '' && method !== '' && start_date !== '' ? (
          <div className="audit-width row">
            <div className="border-bottom mt-25">
              <span className="header font-21">
                {t('audit.create-audit-summary.audit-details')}
              </span>
            </div>

            <div className="col-12 mt-15">
              <label for="inputEmail4">
                {paneState.modalFor === 'Template' ? 'Template Name' : 'Audit Name'}
              </label>
              <input
                className="form-control"
                type="text"
                disabled="disabled"
                value={name}
                defaultValue="Template Name"
              />
            </div>

            <div className="col-12 mt-15">
              <label for="inputEmail4">{t('audit.create-audit-summary.audit-method')}</label>
              <input
                className="form-control"
                type="text"
                disabled="disabled"
                value={
                  method === 'prompt_each_time'
                    ? 'Prompt Each Time'
                    : method === 'manually_enter_id'
                    ? 'Manual Enter Id'
                    : 'Barcode Scan'
                }
                defaultValue="Audit Method"
              />
            </div>

            <div className="row col-12 padding-right-0 mt-15">
              <div className="col-6 padding-right-0">
                <label for="inputEmail4">{t('audit.create-audit-summary.start-date')}</label>
                <DatePicker
                  placeholderText="mm/dd/yyyy"
                  className="form-control"
                  disabled="disabled"
                  selected={new Date(start_date)}
                />
              </div>

              <div className="col-6 padding-right-0">
                <label for="inputEmail4">{t('audit.create-audit-summary.due-date')}</label>
                <DatePicker
                  placeholderText="mm/dd/yyyy"
                  className="form-control"
                  disabled="disabled"
                  selected={due_date ? new Date(due_date) : ''}
                />
              </div>
            </div>

            {due_date && (
              <div className="col-12 mt-20">
                <div className="styled_checkbox styled_checkbox_disabled">
                  <Form.Check
                    type="checkbox"
                    aria-label="option 1"
                    label="Allow Scanning after due date"
                    checked={allow_scanning_after_due_date}
                    disabled={true}
                  />
                </div>
                <label for="inputEmail4" className="mt-15">
                  {t('audit.create-audit-summary.due-soon-notif')}
                </label>
                <br />
                <span className="label-color-size-2">
                  {due_soon_days} {t('audit.create-audit-summary.days-before-due-date')}
                </span>
              </div>
            )}

            {paneState.modalFor === 'Audit' && paneState.modalType === 'edit' ? null : (
              <div className="col-12 mt-15">
                <div className="recurring-input mt-0">
                  <div className="rec-border">
                    <span className="label-color-size">
                      {t('audit.create-audit-summary.recurring')}
                    </span>
                    <Form.Check
                      type="switch"
                      id="custom-switch1"
                      className="ap-toggle"
                      label=""
                      checked={recurrence_attributes.status}
                      disabled={true}
                    />
                  </div>

                  <div className="mt-7">
                    {!recurrence_attributes.status ? (
                      <span className="label-color-size-2">
                        {t('audit.create-audit-summary.does-not-repeat')}
                      </span>
                    ) : (
                      <span className="label-color-size-2">
                        {auditRecurringFormatter(recurrence_attributes)}
                      </span>
                    )}
                  </div>
                  <div className="mt-7">
                    <label for="inputEmail4">
                      {t('audit.create-audit-summary.due-soon-notif')}
                    </label>
                    <br />
                    <span className="label-color-size-2 mt-7">
                      {recurrence_attributes.audit_appear_days}{' '}
                      {t('audit.create-audit-summary.days-before-start-date')}
                    </span>
                  </div>
                </div>
              </div>
            )}
            <div className="styled_checkbox styled_checkbox_disabled col-12 mt-15">
              <Form.Check
                type="checkbox"
                aria-label="option 1"
                label="Record GPS Location"
                checked={gps_location}
                disabled={true}
              />

              <Form.Check
                type="checkbox"
                aria-label="option 1"
                label="Show Asset Details After Each Scan"
                checked={asset_details}
                disabled={true}
              />

              <Form.Check
                type="checkbox"
                aria-label="option 3"
                label="Signature to Close Audit"
                checked={signature}
                disabled={true}
              />
            </div>

            <div className="border-bottom mt-20">
              <span className="header font-21">
                {t('audit.create-audit-summary.group-details')}
              </span>
            </div>

            <div className="col-12 mt-15">
              <label for="inputEmail4">{t('audit.create-audit-summary.group-name')}</label>
              <input
                className="form-control"
                type="text"
                disabled="disabled"
                value={audit_entities_attributes[0].entity_name}
                defaultValue="Group Name"
              />
            </div>

            <div className="col-12 mt-15">
              <label for="inputEmail4">{t('audit.create-audit-summary.display-field')}</label>
              <input
                className="form-control"
                type="text"
                disabled="disabled"
                value={audit_entities_attributes[0].audit_entity_field_attributes.field_name}
                defaultValue="Display Field"
              />
            </div>

            {audit_entities_attributes[0].audit_entity_filters_attributes.length > 0 && (
              <div className="col-12 mt-15">
                <label for="inputEmail4">{t('audit.create-audit-summary.filter')}</label>
                <div className="row col-12 input-data not-allowed">
                  {getFilterWithCounts().map((Filter, index) => (
                    <div className="filter">
                      {Filter.field_name} ({Filter.count})
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div className="col-12 mt-15">
              <span className="label-color-size">
                Automatically Update Fields <br />
                <small>Automatically update select fields of scanned items.</small>
              </span>
              <Form.Check
                type="switch"
                id="custom-switch"
                label=""
                className="ap-toggle not-allowed"
                checked={allow_auto_update_fields}
                disabled={true}
              />
              <br />
              {allow_auto_update_fields && (
                <div className="row col-12 input-data not-allowed mt-15">
                  {audit_entities_attributes[0].audit_entity_auto_update_fields_attributes.map(
                    filter => {
                      return <div className="filter">{auditFilterFormatter(filter)}</div>
                    }
                  )}
                </div>
              )}
            </div>
            <hr className="border-adujst" />
            <div className="col-12">
              <span className="label-color-size">
                {t('audit.create-audit-summary.allow-users-to-update-fields')} <br />
                <small>Allow users to edit select fields.</small>
              </span>
              <Form.Check
                type="switch"
                id="custom-switch1"
                className="ap-toggle not-allowed"
                label=""
                checked={allow_user_update_fields}
                disabled={true}
              />
              <br />

              {allow_user_update_fields && (
                <>
                  <Form.Check
                    className="styled_checkbox styled_checkbox_disabled pl-0 col-12 mt-15"
                    type="checkbox"
                    aria-label="checkbox"
                    label="Allow users without write permissions to update fields"
                    checked={allow_user_without_edit_permission}
                    disabled={true}
                  />
                  <div className="row col-12 input-data not-allowed mt-15">
                    {audit_entities_attributes[0].audit_entity_user_fields_attributes.map(
                      (Filter, index) => (
                        <div className="filter">{Filter.field_name}</div>
                      )
                    )}
                  </div>
                </>
              )}
            </div>

            <div className="border-bottom width-64 mt-18 pb-11 pt-3">
              <span className="header font-21">{t('audit.create-audit-summary.assign-audit')}</span>
            </div>
            <div className="col-12 mt-3">
              <Form.Check
                type="switch"
                id="customSwitches"
                className="ap-toggle"
                label=""
                checked={individual_audit}
              />
              <h6 className="gray-color">Individual Audit</h6>
              <p className="borderBottom pb-1 mb-1 small gray-color">
                Each user has to finish their part of the audit.
              </p>
            </div>
            <div className="col-12 mt-15">
              <label for="inputEmail4">{t('audit.create-audit-summary.assign-to-user')}</label>
              <div className="row col-12 input-data not-allowed">
                {audit_users_attributes.map((user, index) => (
                  <div className="filter">{user.user_name}</div>
                ))}
              </div>
            </div>
            {audit_user_templates_attributes.length > 0 && (
              <div className="col-12 mt-15">
                <label for="inputEmail4">
                  {t('audit.create-audit-summary.assign-to-templates')}
                </label>
                <div className="row col-12 input-data not-allowed">
                  {audit_user_templates_attributes.map((template, index) => (
                    <div className="filter">{template.template_name}</div>
                  ))}
                </div>
              </div>
            )}
            {audit_email_users_attributes.length > 0 && (
              <div className="col-12 mt-15">
                <label for="inputEmail4">
                  {t('audit.create-audit-summary.assign-to-Email-user')}
                </label>
                <div className="row col-12 input-data not-allowed">
                  {audit_email_users_attributes.map((user, index) => (
                    <div className="filter">{user.user_name}</div>
                  ))}
                </div>
              </div>
            )}
          </div>
        ) : (
          <div className="msg">
            <p className="warning-msg">
              Please provide all of the neccesary details to create audit
            </p>
          </div>
        )}
      </form>
    </>
  )
}

export default withTranslation()(Summary)
